<template>
  <div id="gwi-profile" class="app">
    <div class="main mybgcolor" @refresh="refresh">
      <div class="mylogin arr-row click-toPerson" @click="goPersonal">
        <div class="myphoto"></div>
        <div class="mymessage">
          <p class="nickname">{{ user.nickName }}</p>
          <p class="phoneno">手机号： {{ user.mobileNo | dotted }}</p>
        </div>
      </div>
    </div>
    <scroll class="to-profile" @refresh="refresh">
      <section class="row">
        <button
          id="profile-btn-addVoucher"
          class="btn-ok"
          type="button"
          :disabled="3 == voucherList.length"
          @click="goAddVoucher"
        >
          办卡/绑卡
        </button>
        <p class="f-minor text-center mytips">
          <span id="profile-span-full" v-if="3 == voucherList.length"
            >就诊凭证已满，如需绑定请先解绑其他就诊凭证</span
          >
          <span id="profile-span-empty" v-else-if="0 == voucherList.length"
            >请绑定就诊凭证</span
          >
          <span id="profile-span-normal" v-else
            >还能绑定<span id="profile-span-surplus" class="mygray">{{
              3 - voucherList.length
            }}</span
            >张就诊凭证</span
          >
        </p>
      </section>
      <div
        v-for="(voucher, index) in voucherList"
        :key="index"
        class="voucher-list"
        :class="0 == index ? 'selected' : ''"
        @click="selectVoucher(voucher, index, $event)"
      >
        <health-card
          :id="'profile-voucherItem-' + voucher.cardNo"
          :data="voucher"
          :edit="0"
          :is-frequent="index === 0"
        ></health-card>
      </div>
    </scroll>
  </div>
</template>
<script>
import personalService from 'personal.service'
import voucherService from 'voucher.service'
import VoucherItem from '../voucher/VoucherItem'
import HealthCard from 'health-card-swiper/health-card.vue'

export default {
  components: {
    VoucherItem,
    HealthCard
  },
  data () {
    return {
      usermessage: [],
      voucherList: []
    }
  },
  created () {
    //判断是否存在tokenId,且当前界面code失效
    var query = this.$router.currentRoute.query
    var code = query.code
    if (code) {
      var getTokenParams = { code: code }
      voucherService.getToken(getTokenParams).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          //查询该用户未使用过该公众号
          this.refresh()
          return
        }
        //缓存最新code给后台
        localStorage.setItem('deviceId', code);
        sessionStorage.setItem('deviceId', code);
        //返回新token保存本地使用
        localStorage.tokenId = res.data.tokenId;
        localStorage.setItem('tokenId', res.data.tokenId);
        sessionStorage.setItem('tokenId', res.data.tokenId);
        window.http.headers.common['tokenId'] = localStorage.tokenId || ''
        window.http.headers.common['deviceId'] = localStorage.deviceId || ''
        this.refresh()
      })
    } else {
      this.refresh()
    }
  },
  methods: {
    goPersonal () {
      this.$router.push('personal');
    },
    refresh () {
      personalService.getUserInfo().then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg)
        } else {
          this.usermessage = res.data
        }
        voucherService.getVoucherList().then((res) => {
          if (res.resultCode !== this.constant.RESULT_SUCCESS) {
            this.$utils.alert(res.resultMsg)
            return
          }
          this.voucherList = res.data
        })
      })
    },
    selectVoucher (voucher) {
      this.$store.commit('updateParam', {
        namespace: 'detail',
        voucher: voucher
      });
      this.$router.push('voucherDetail');
    },
    goAddVoucher () {
      this.$router.push({
        path: 'voucherChooseType'
      });
    }
  },
  computed: {
    user () {
      var mobileNo = this.usermessage.mobileNo;
      var nickName = this.usermessage.name;
      return {
        nickName: nickName,
        mobileNo: mobileNo
      }
    }
  }
}
</script>
<style lang="scss">
@import "../../../static/sass/_variable.scss";
.mybgcolor {
  background-color: $common-bg-color;
  .arr-row {
    border-bottom: none;
    &::after {
      right: 10px;
    }
  }
}
.mylogin {
  @include display-flex();
  @include align-items(center);
  height: 40px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 10px;
  background-color: #fff;
  padding-bottom: 10px;
  margin-bottom: 0.5rem;
  .camera {
    width: 38px;
    height: 34px;
    background: url(../../../static/img/camera.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .myphoto {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: url(../../../static/img/my-login.png);
    background-size: contain;
  }
  .mymessage {
    @include flex(1);
    width: 1px;
    padding: 0 10px;
    .nickname {
      font-size: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .phoneno {
      font-size: 15px;
      color: #ccc;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .myedit {
    width: 26px;
    height: 26px;
    background: url(../../../static/img/my-edit.png);
    background-size: contain;
  }
}
.scroll.to-profile {
  top: 1.8rem;
  bottom: 1.95rem;
  .btn-ok {
    &:disabled {
      background: #ccc;
      color: #fff;
      box-shadow: none;
    }
  }
  .mytips {
    margin-top: 13px;
    .mygray {
      color: #333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Profile.vue?6f3eea30